import TotalSalesBreakdown from '../../breakdown/TotalSalesBreakdown/components/TotalSalesBreakdown';
import TotalSalesBreakdownContainer from '../../breakdown/TotalSalesBreakdown/containers/TotalSalesBreakdown';
import { fetchProductBreakdown } from '../../metrics/actions';


export default TotalSalesBreakdownContainer(fetchProductBreakdown)(TotalSalesBreakdown);
